module.exports = __webpack_public_path__ + "static/media/blueTheme-boy.bf855312.svg";